import { render, staticRenderFns } from "./tbxbcb.vue?vue&type=template&id=f992f8d4&scoped=true&"
import script from "./tbxbcb.vue?vue&type=script&lang=js&"
export * from "./tbxbcb.vue?vue&type=script&lang=js&"
import style0 from "./tbxbcb.vue?vue&type=style&index=0&id=f992f8d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f992f8d4",
  null
  
)

export default component.exports